export default "__VITE_PUBLIC_ASSET__f316e7cf__"